import { ReactNode } from "react";
import { Typography } from "@mui/material";
import styles from "./MediumText.module.css";

interface Props {
  children?: ReactNode;
  color?: String;
  fWeight?: String;
  mt?: any;
  mb?: any;
  mr?: any;
  ml?: any;
  textAlign?: String;
  display?: String;
  float?: String;
  height?: any;
  padding?: any;
  alignSelf?: string;
  whiteSpace?: string;
  textdecor?: boolean;
  overflow?: any;
  textOverflow?: any;
  // any props that come into the component
}

export default function MediumText({ children, color, fWeight, mt, mb, textAlign, display, ml, mr, float, height, padding, alignSelf, whiteSpace, textdecor, overflow="visible", textOverflow="clip" }: Props) {
  return (
    <Typography 
    textAlign="center"
    className={textOverflow === "ellipsis" ? styles.block : ""}
    sx={{
      fontFamily: 'DMSans',
      mt: mt,
      mb: mb,
      mr: mr,
      ml: ml,
      color: `${color}`,
      fontWeight: `${fWeight}`,
      fontSize: {xs: 12, md: 16},
      letterSpacing: 0,
      textAlign: `${textAlign}`,
      display: `${display}`,
      float: `${float}`,
      height: `${height}`,
      padding: `${padding}`,
      alignSelf: `${alignSelf}`,
      whiteSpace: `${whiteSpace}`,
      ...(textdecor ? {
        textDecoration: "underline",
      } : {
        textDecoration: "none"
      })
    }}
    overflow={overflow}
    textOverflow={textOverflow}
    >
      {children}
    </Typography>
  );
}
